import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UrlComparisonType, UrlComparisonTypeValue } from '../../../../shared/domain/url.comparison.type';
import { FormGroup } from '@angular/forms';
import { ItemService } from '../item.service';

@Component({
  selector: 'cc-item-select',
  templateUrl: './item-select.component.html',
  styleUrls: ['./item-select.component.scss']
})
export class ItemSelectComponent implements OnInit, OnDestroy {
  @Input() public form: FormGroup;
  @Input() public urlComparisonTypesKeys = Object.keys(UrlComparisonType);
  public urlComparisonTypes = UrlComparisonTypeValue;

  constructor(private itemService: ItemService) {}

  ngOnInit() {
    this.itemService.addField(this.form, {
      urlComparisonType: UrlComparisonType.CONTAINS_THE_STRING
    });
  }

  ngOnDestroy(): void {
    this.form.removeControl('urlComparisonType');
  }
}
